import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/** Where a signed-in visitor belongs instead of the marketing landing page. */
export const DASHBOARD_ROUTE = '/build?view=dashboard';

/**
 * Wraps the marketing landing page so only signed-out visitors ever see it.
 *
 * The landing page is a pitch: a hero asking "What do you wanna build?", the
 * business section, the FAQ. None of it is addressed to someone who already has
 * an account, and it hides the thing they actually came back for — their sites,
 * their credits, their dashboard prompt box. So a session that resolves to a
 * user is sent straight to the workspace dashboard.
 *
 * AuthModal already does this for the moment of signing in. This covers every
 * other way in: a bookmark, typing builderslab.net, the navbar logo, or
 * Workspace bouncing a bare /build back to `/`.
 *
 * `replace` rather than a push, and that matters: pushed, `/` would sit in
 * history directly behind the dashboard, so Back would land on it, redirect
 * forward again, and trap the user on a page they cannot leave backwards.
 */
export default function SignedOutOnly({ children }) {
  const { user, loading } = useAuth();

  // AuthenticatedApp holds a spinner until auth resolves, so this is belt and
  // braces — but rendering the pitch for one frame and yanking it away is the
  // one failure worth being sure of.
  if (loading) return null;

  if (user) return <Navigate to={DASHBOARD_ROUTE} replace />;

  return children;
}
